module.exports = __webpack_public_path__ + "static/media/searchbar.352ec88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Features/searchbar.png
// module id = 640
// module chunks = 0